import React from "react";

const SpaceIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22" height="22" rx="5" fill="#00a799" />
      <circle cx="11" cy="14" r="2" fill="white" />
      <path d="M5.5 14L11 12V16L5.5 14Z" fill="white" />
      <circle cx="14" cy="8" r="2" fill="white" />
    </svg>
  );
};

export default SpaceIcon;
